<!--
	TEMPLATE
-->
<template>
<div class="editable-checkboxes">

	<div v-if="!isEditView">
		<p v-for="label in labels"><span v-if="values.length !== 0">{{ label }}</span><span v-if="values.length === 0">None</span></p>
	</div>
	<div v-if="isEditView">
		<div v-for="item in options.items" class="col">
			<div class="mdc-form-field" :class="{'col-xs-12': options.cols === 1, 'col-sm-6': options.cols === 2}">
				<div class="mdc-checkbox">
					<input :id="item[ID]" :value="item[ID]" class="mdc-checkbox__native-control" type="checkbox" v-model="values" :disabled="!isEditView">
					<div class="mdc-checkbox__background">
						<svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
						  <path class="mdc-checkbox__checkmark-path"
								  fill="none"
								  stroke="white"
								  stroke-width="3.5px"
								  d="M1.73,12.91 8.1,19.28 22.79,4.59"/>
						</svg>
						<div class="mdc-checkbox__mixedmark"></div>
					</div>
				</div>
				<label :for="item[ID]">{{ item[TEXT] }}</label>
			</div>
		</div>
	</div>

</div>
</template>

<!--
	SCRIPT
-->
<script>
import vModelNested from '@/libs/vModelNested.js';

export default {
	props: {
		value: {
			type: [Array, Object],
			default: function() {
				return []
			}
		},
		options: Object,
		isEditView: Boolean
	},
	data: function() {
		return {
			ID: 0,
			TEXT: 1,
			showOptions: false
		}
	},
	computed: {
		labels: function() {
			var self = this
			var labels = ''
			if(this.values.length === this.options.items.length || this.values.length === 0) {
				labels = 'All'
			} else {
				Object.keys(this.options.items).forEach(function(item) {
					if (self.values.indexOf(self.options.items[item][self.ID]) !== -1) {
						labels += self.options.items[item][self.TEXT] + ', '
					}
				});
			}
			return labels.split(',')
		},
		values: vModelNested
	}
}
</script>



// WEBPACK FOOTER //
// src/components/editable-items/EditableCheckboxes.vue